import { ApexOptions } from 'apexcharts'
import ReactApexChart from 'react-apexcharts'
import { useTranslation } from 'react-i18next'

import { ChartData, getBarChartOptionsAndData } from './dataConverter'
import '../ChartError.scss'
import '../Charts.scss'

interface Param {
  salesData: ChartData | undefined
  showLegend: boolean
}

export function AcBarChart({
  salesData = undefined,
  showLegend = false,
}: Param) {
  const { t } = useTranslation()

  if (!salesData) {
    return <div></div>
  }

  let options
  let data

  try {
    const result = getBarChartOptionsAndData(salesData, showLegend)
    options = result.options
    data = result.data
  } catch (error) {
    console.error(
      'Error processing bar chart data:',
      error instanceof Error ? error.message : 'Unknown error',
    )
    return (
      <div className="chart-error">
        {t('components.dashboard.chart.unableToRender')}
      </div>
    )
  }

  return (
    <div className="AcBarChart">
      <ReactApexChart
        options={options as unknown as ApexOptions}
        series={data}
        type={(options.chart?.type as 'bar' | 'line') || 'bar'}
        width="100%"
        height="100%"
      />
    </div>
  )
}
